import type { AIDTColor } from './_typing';

export const pink: AIDTColor = Object.freeze({
  50: '#fce4ec',
  100: '#F7E1ED',
  200: '#EEC4DB',
  300: '#E6A6C8', // math elementary key
  400: '#DD89B6',
  500: '#D56BA4', // math middle key
  600: '#BF5392',
  700: '#A93B7F',
  800: '#93226C',
  900: '#7D0A5A', // math high bg
  950: '#53073C',
  0: '#2A031E', // math high key
} as const);
